import React, { useState, useMemo, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
} from "reactstrap";

import BreadCrumb from "../../../Components/Common/BreadCrumb";

// Import service pages
import Menu from "./Menu";
import Housekeeping from "./Housekeeping";
import ManageSpa from "./ManageSpa";
// import Wellness from "./Wellness";
// import Events from "./Events";
// import DealsManagement from "./Deals";
import ManageCoupons from "./Coupons";

const allServices = [
  "Menu (Food & Beverages)",
  "Housekeeping Services",
  "Spa",
  // "Wellness",
  // "Events",
  // "Deals",
  "Coupons",
];

const componentMap = {
  "Menu (Food & Beverages)": <Menu />,
  "Housekeeping Services": <Housekeeping />,
  "Spa": <ManageSpa />,
  // "Wellness": <Wellness />,
  // "Events": <Events />,
  // "Deals": <DealsManagement />,
  "Coupons": <ManageCoupons />,
};

const ManageServices = () => {
  // ✅ Logged user
  const user = JSON.parse(localStorage.getItem("user"));
  const role = user?.role?.toLowerCase();
  const dept = user?.department;


  // ✅ FILTER SERVICES BASED ON ROLE + DEPT
const serviceCategories = useMemo(() => {

  // ✅ ADMIN + CLIENT → ALL ACCESS
  if (role === "admin" || role === "client") {
    return allServices;
  }

  // ✅ MANAGER FILTERS
  if (role === "manager") {

    switch (dept) {

      case "Housekeeping":
        return ["Housekeeping Services"];

      case "F&B":
        return ["Menu (Food & Beverages)", "Deals", "Coupons"];

      case "Spa":
        return ["Spa", "Deals", "Coupons"];

      case "Front-Office":
        return ["Coupons"];

      case "Management":
        return allServices;

      default:
        return [];
    }
  }

  return [];

}, [role, dept]);



  // ✅ default selection fix (important)

  const [activeService, setActiveService] = useState("");

useEffect(() => {
  if (serviceCategories.length > 0) {
    setActiveService(serviceCategories[0]);
  }
}, [serviceCategories]);


console.log("ROLE:", role);
console.log("DEPT:", dept);
console.log("SERVICES:", serviceCategories);
console.log("ACTIVE:", activeService);
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Manage Services" pageTitle="Admin" />

        <Row>
          {/* LEFT PANEL */}
          <Col xl={3} lg={4}>
            <Card>
              <CardHeader>
                <h5 className="fs-16 mb-0">Services</h5>
              </CardHeader>

              <ListGroup flush>
                {serviceCategories.map((service) => (
                  <ListGroupItem
                    key={service}
                    tag="button"
                    action
                    onClick={() => setActiveService(service)}
                    className={
                      activeService === service ? "active fw-bold" : ""
                    }
                  >
                    {service}
                  </ListGroupItem>
                ))}
              </ListGroup>
            </Card>
          </Col>

          {/* RIGHT PANEL */}
          <Col xl={9} lg={8}>
            {componentMap[activeService] || (
              <div className="text-muted p-3">No Service доступ</div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ManageServices;